import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { FormattedIntlCurrency } from 'I18n/components/FormattedIntlCurrency';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { Text } from 'foundations-components/components/Text';
import { ALL_PIPELINES_QUERY_PARAM } from '../../constants/CrmSearchConstants';
import { StyledCurrencyWrapper } from '../../utils/StyledCurrencyWrapper';
import { trackReassignDealsForDeactivatedUser } from '../../utils/usageTracker';
import { getFilteredDealsUrl } from '../../utils/urls';
import { makeDealFilterGroupByOwnerQuery } from '../../utils/filters';
import { getIsDealStageView } from '../../selectors/forecastSelectors';
import { getFetchOwnersSucceeded } from '../../selectors/ownersSelectors';
import { RightAlignedTD } from '../styled/RightAlignedTD';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CoverageCell = ({
  isDetailPage,
  rowData
}) => {
  const {
    id,
    isUser,
    isActive,
    totalForecastedAmount
  } = rowData;
  const isDealStageView = useSelector(getIsDealStageView);
  const isOwnersFetchSucceeded = useSelector(getFetchOwnersSucceeded);
  const viewDealsLinkHref = getFilteredDealsUrl(makeDealFilterGroupByOwnerQuery({
    id
  }), ALL_PIPELINES_QUERY_PARAM // We want to show open deals for all pipelines
  );
  const handleClick = useCallback(() => {
    trackReassignDealsForDeactivatedUser(isDetailPage, isDealStageView);
  }, [isDealStageView, isDetailPage]);
  return /*#__PURE__*/_jsx(RightAlignedTD, {
    children: /*#__PURE__*/_jsxs("span", {
      "data-test-id": "coverage-amount",
      children: [/*#__PURE__*/_jsx(StyledCurrencyWrapper, {
        children: /*#__PURE__*/_jsx(FormattedIntlCurrency, {
          value: totalForecastedAmount.value,
          currencyCode: totalForecastedAmount.currencyCode
        })
      }), isUser && !isActive && isOwnersFetchSucceeded && /*#__PURE__*/_jsx("div", {
        "data-test-id": "reassign-open-deals-link",
        children: /*#__PURE__*/_jsx(Text, {
          as: "small",
          children: /*#__PURE__*/_jsx(Link, {
            href: viewDealsLinkHref,
            onClick: handleClick,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "repOverviewTable.coverageCell.reassignOpenDeals"
            })
          })
        })
      })]
    })
  });
};
export default CoverageCell;